var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngineeringForFreedom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "960px",
    height: "57.4px",
    viewBox: "0 0 960 57.4",
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 960 57.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "0,56.7 0,19.9 25.8,19.9 25.8,26.8 7.8,26.8 7.8,34.7 20.5,34.7 20.5,41.6 7.8,41.6 7.8,49.8 26,49.8  26,56.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "68.7,56.7 50.4,32.7 50.4,56.7 42.7,56.7 42.7,19.9 49.9,19.9 67.7,43.2 67.7,19.9 75.4,19.9  75.4,56.7  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M110.9,57.4c-11.2,0-19.4-8-19.4-19v-0.1c0-10.7,8.5-19.1,19.3-19.1c6,0,10.2,1.4,14.4,4.9l-4.9,5.9 c-2.8-2.3-5.4-3.7-9.7-3.7c-6,0-10.9,5.3-10.9,11.8v0.1c0,7,4.8,12,11.5,12c3.1,0,5.8-0.8,7.8-2.3L119,48v-5.6h-8.2v-6.7h15.8v15.9 C122,55.4,116.7,57.4,110.9,57.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.9,
    y: 19.9,
    fill: "#FFFFFF",
    width: 7.8,
    height: 36.9
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "195.9,56.7 177.5,32.7 177.5,56.7 169.8,56.7 169.8,19.9 177.1,19.9 194.8,43.2 194.8,19.9  202.5,19.9 202.5,56.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "220.6,56.7 220.6,19.9 246.3,19.9 246.3,26.8 228.3,26.8 228.3,34.7 241.1,34.7 241.1,41.6  228.3,41.6 228.3,49.8 246.6,49.8 246.6,56.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "263.2,56.7 263.2,19.9 289,19.9 289,26.8 271,26.8 271,34.7 283.7,34.7 283.7,41.6 271,41.6 271,49.8  289.3,49.8 289.3,56.7  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M328.4,56.7l-8-11.9h-6.7v11.9h-7.8V19.9h16.8c8.7,0,13.8,4.5,13.8,12.1v0.1c0,5.5-2.8,9.5-7.9,11.4l-0.2,0.1 l9,13.2H328.4z M313.7,38h8.5c4,0,6.5-2.1,6.5-5.5v-0.1c0-3.5-2.4-5.5-6.6-5.5h-8.3V38z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "353,56.7 353,19.9 378.7,19.9 378.7,26.8 360.7,26.8 360.7,34.7 373.5,34.7 373.5,41.6 360.7,41.6  360.7,49.8 379,49.8 379,56.7  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M395.6,56.7V19.9H410c11.4,0,19.6,7.7,19.6,18.3v0.1c0,10.7-8.2,18.4-19.6,18.4H395.6z M403.4,49.7h6.5 c6.8,0,11.4-4.5,11.4-11.3v-0.1c0-6.7-4.7-11.4-11.4-11.4h-6.5V49.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "469.5,56.7 469.5,19.9 495.5,19.9 495.5,27 477.3,27 477.3,35.3 490.3,35.3 490.3,42.3 477.3,42.3  477.3,56.7  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M525.6,57.4c-11.1,0-19.5-8.1-19.5-19v-0.1c0-10.7,8.6-19.1,19.6-19.1c11.1,0,19.5,8.1,19.5,19v0.1 C545.3,49,536.7,57.4,525.6,57.4z M525.6,26.4c-6.5,0-11.4,5.1-11.4,11.8v0.1c0,6.7,5,11.9,11.5,11.9c6.5,0,11.4-5.1,11.4-11.8 v-0.1C537.1,31.6,532.1,26.4,525.6,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M580.3,56.7l-8-11.9h-6.7v11.9h-7.8V19.9h16.8c8.7,0,13.8,4.5,13.8,12.1v0.1c0,5.5-2.8,9.5-7.9,11.4l-0.2,0.1 l9,13.2H580.3z M565.6,38h8.5c4,0,6.5-2.1,6.5-5.5v-0.1c0-3.5-2.4-5.5-6.6-5.5h-8.3V38z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "629.6,56.7 629.6,19.9 655.6,19.9 655.6,27 637.4,27 637.4,35.3 650.4,35.3 650.4,42.3 637.4,42.3  637.4,56.7  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M690.4,56.7l-8-11.9h-6.7v11.9h-7.8V19.9h16.8c8.7,0,13.8,4.5,13.8,12.1v0.1c0,5.5-2.8,9.5-7.9,11.4l-0.2,0.1 l9,13.2H690.4z M675.7,38h8.5c4,0,6.5-2.1,6.5-5.5v-0.1c0-3.5-2.4-5.5-6.6-5.5h-8.3V38z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "715,56.7 715,19.9 740.7,19.9 740.7,26.8 722.7,26.8 722.7,34.7 735.5,34.7 735.5,41.6 722.7,41.6  722.7,49.8 741,49.8 741,56.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "757.6,56.7 757.6,19.9 783.4,19.9 783.4,26.8 765.4,26.8 765.4,34.7 778.1,34.7 778.1,41.6  765.4,41.6 765.4,49.8 783.7,49.8 783.7,56.7  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M800.3,56.7V19.9h14.3c11.4,0,19.6,7.7,19.6,18.3v0.1c0,10.7-8.2,18.4-19.6,18.4H800.3z M808.1,49.7h6.5 c6.8,0,11.4-4.5,11.4-11.3v-0.1c0-6.7-4.7-11.4-11.4-11.4h-6.5V49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00CCBE",
    d: "M862,38.1c-11.1,0-19.5-8.1-19.5-19v-0.1c0-10.7,8.6-19.1,19.6-19.1c11.1,0,19.5,8.1,19.5,19v0.1 C881.6,29.8,873,38.1,862,38.1z M862,7.2c-6.5,0-11.4,5.1-11.4,11.8v0.1c0,6.7,5,11.9,11.5,11.9c6.5,0,11.4-5.1,11.4-11.8v-0.1 C873.5,12.4,868.4,7.2,862,7.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "921.7,56.7 921.7,32 910.9,48.3 910.9,48.3 900.3,32.1 900.3,56.7 892.6,56.7 892.6,19.9 901.1,19.9  911,35.8 920.9,19.9 929.5,19.9 929.5,56.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M942.1,15.2h-1.9v-9h-3.4V4.4h8.8v1.8h-3.4V15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M954.7,12.5L954.7,12.5l-3.4-5.1v7.7h-1.9V4.4h2l3.3,5.1l3.3-5.1h2v10.8h-1.9V7.4L954.7,12.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineeringForFreedom);
export default __webpack_public_path__ + "static/media/engineering-for-freedom.c2e67b874812d29d51a4b00f4c269ab8.svg";
export { ForwardRef as ReactComponent };